module.exports = __webpack_public_path__ + "static/media/transaction2.a76ac666.png";